import { Progress } from '@base-ui/react/progress'
import { twMerge } from 'tailwind-merge'
import type { PartProps } from '../../../lib/part-props'

interface ProgressLabelProps extends PartProps<Progress.Label.Props> {
  className?: string
}

function ProgressLabel({ className, children, ...props }: ProgressLabelProps) {
  return (
    <Progress.Label className={twMerge('text-foreground-secondary text-sm font-medium', className)} {...props}>
      {children}
    </Progress.Label>
  )
}

export { ProgressLabel }
